import React, {
  PropTypes as T,
} from 'react';
import radium from 'radium';
import * as DetectionActions from '../../actions/Detection.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Helpers from '../../helpers';

const styles = {
  wrap: {
    display: 'none',
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, .38)',
  },
  shown: {
    display: 'block',
  },
  container: {
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
  form: {
    width: 500,
    height: 'calc(100vh - 180px)',
    minHeight: 399,
    backgroundColor: '#eee',
    position: 'relative',
    overflow: 'auto',
    marginBottom: 90,
    marginTop: 90,
    borderRadius: 10,
    '@media (max-width: 767px)': {
      width: '100%',
      height: '100%',
      maxHeight: 399,
    }
  },
  form_TV: {
    width: '50%',
    height: '35%',
    minHeight: 399,
    backgroundColor: '#eee',
    position: 'relative',
    overflow: 'auto',
    marginBottom: 90,
    marginTop: 90,
    borderRadius: 10
  },
  contentWrap: {
    padding: 20,
    textAlign: 'center',
  },
  content: {
    height: 'calc(100% - 52px)',
    overflow: 'auto',
  },
  title: {
    display: 'block',
    fontSize: 18,
  },
  title_TV: {
    display: 'block',
    fontSize: 26
  },
  listWrap: {
    padding: 20,
    overflow: 'auto',
    margin: 0,
    '@media (max-width: 767px)': {
      padding: 10,
    },
  },
  listItem: {
    listStyle: 'none',
    lineHeight: 2,
    color: '#4a4a4a',
    fontWeight: 300,
    letterSpacing: 1,
    position: 'relative',
    margin: '0px 0px 10px 0px',
    '@media (max-width: 767px)': {
      fontSize: 13,
      lineHeight: 1.5,
    },
  },
  listIndex: {
    fontSize: 14,
    textAlign: 'center',
  },
  listIndex_TV: {
    fontSize: 22,
    textAlign: 'center',
  },
  bottomWrap: {
    width: '100%',
    textAlign: 'center',
    position: 'absolute',
    bottom: 0,
    lineHeight: '52px',
    padding: 0,
    textDecoration: 'none',
    color: '#4A4A4A',
    borderTop: '1px solid #D8D8D8',
    letterSpacing: 1.5,
    fontSize: 24,
    backgroundColor: 'transparent',
    borderLeft: 0,
    borderRight: 0,
    borderBottom: 0,
    cursor: 'pointer'
  },
  bottomWrap_TV:{
    width: '100%',
    textAlign: 'center',
    position: 'absolute',
    bottom: 0,
    lineHeight: '52px',
    padding: 0,
    textDecoration: 'none',
    color: '#4A4A4A',
    borderTop: '1px solid #D8D8D8',
    letterSpacing: 1.5,
    fontSize: 32,
    backgroundColor: 'transparent',
    borderLeft: 0,
    borderRight: 0,
    borderBottom: 0,
    cursor: 'pointer',
  },
  h1: {
    position: 'relative',
    margin: '10px 0 0 0',
    color: '#000',
    fontSize: 18,
    lineHeight: '32px',
    textAlign: 'center',
    letterSpacing: 2,
    '@media (max-width: 767px)': {
      fontSize: 15,
    }
  },
  h1_TV:{
    position: 'relative',
    margin: '10px 0 0 0',
    color: '#000',
    fontSize: 26,
    lineHeight: '32px',
    textAlign: 'center',
    letterSpacing: 2
  },
  text: {
    outline: 'none',
    border: 0,
    backgroundColor: 'transparent',
    fontSize: 15,
    '@media (max-width: 767px)': {
      fontSize: 12,
    },
  },
};

function DetectionRuleModal(props) {
  const {
    isShownRuleModal,
    closeRuleModal,
  } = props;

  var form = styles.form;
  var title = styles.title;
  var listIndex = styles.listIndex;
  var bottomWrap = styles.bottomWrap;
  var h1 = styles.h1;

  if (Helpers.Session.isViaTV()) {
    form = styles.form_TV;
    title = styles.title_TV;
    listIndex = styles.listIndex_TV;
    bottomWrap = styles.bottomWrap_TV;
    h1 = styles.h1_TV;
  }


  return (
    <div style={[styles.wrap, isShownRuleModal && styles.shown]}>
      <div style={styles.container}>
        <div style={form}>
          <div style={styles.content}>
            <h1 style={h1}>『蒐集、處理及利用個人資料告知事項』</h1>
            <ul style={styles.listWrap}>
              <li style={styles.listItem}>
                <span style={listIndex}>1.</span>
                科林國際助聽器股份有限公司(下稱本公司)依據個資法第8條為個人資料之蒐集告知。
              </li>
              <li style={styles.listItem}>
                <span style={listIndex}>2.</span>
                本公司於各項活動之特定目的內蒐集、處理及利用您的個人資料，個人資料類別包含姓名、性別、電話及出生年月日等活動所須個人資料，該個人資料利用的期間、地區、對象及方式一個活動辦法暨個資法辦理。
              </li>
              <li style={styles.listItem}>
                <span style={listIndex}>3.</span>
                您所留下的各項資料，僅供本公司為預約到店、通知中獎或通知聽檢結果和行銷活動而需進行聯繫等相關事項以及用於問題統計與分析之特定目的於本公司使用。除此之外，本公司並不會將您所留的資料提供給他人。
              </li>
              <li style={styles.listItem}>
                <span style={listIndex}>4.</span>
                您可隨時依個人資料保護法第3條規定，針對您所留的個人資料，來電(0800-551188)請求停止處理或運用、請求刪除，但若您要求停止處理、利用或刪除個人資料，將無法獲得本公司提供之資訊、服務及相關權益。
              </li>
            </ul>
          </div>
          <button onClick={() => closeRuleModal()} style={bottomWrap}>確認</button>
        </div>
      </div>
    </div>
  );
}

DetectionRuleModal.propTypes = {
  isShownRuleModal: T.bool,
  closeRuleModal: T.func,
};

export default connect(
  state => ({
    isShownRuleModal: state.Detection.isShownRuleModal,
  }),
  dispatch => bindActionCreators(DetectionActions, dispatch),
)(radium(DetectionRuleModal));



// WEBPACK FOOTER //
// ./containers/Detections/DetectionRuleModal.js